import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { open: Boolean }

  connect() {
    this.$modal = $(this.element)
    this.$modal.on("shown.bs.modal", () => {
      // Bootstrap focuses the modal wrapper after the show transition,
      // stealing focus from any autofocused field. Restore it.
      this.element.querySelector("[autofocus]")?.focus()
      this.dispatch("shown")
    })
    this.$modal.on("hidden.bs.modal", () => { this.dispatch("hidden") })

    if (this.openValue) this.open()
  }

  disconnect() {
    this.hide()
  }

  hide(event) {
    event?.preventDefault()
    this.close()
  }

  open() {
    this.$modal.modal("show")
  }

  close() {
    this.$modal.modal("hide")
  }

  remove() {
    this.element.remove()
  }
}
